var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container",attrs:{"id":"map-container"}},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"loader":"bars"},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }